// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var buttonWithIcon = "ModernButton-module--buttonWithIcon--HbPv2";
export var buttonCircle = "ModernButton-module--buttonCircle--d8e5J";
export var buttonArrow = "ModernButton-module--buttonArrow--xA2h5";
export var button = "ModernButton-module--button--XblWP";
export var text = "ModernButton-module--text--xs3Ti";
export var icon = "ModernButton-module--icon--9oFa1";